import { useState } from "react";
import Modal from "../components/Modal";
import Field, { inputStyle, selectStyle, inputErrorStyle } from "../components/Field";
import { REGIONS, FLEET_SIZES } from "../constants";
import { generateId, getToday, maskPhone } from "../utils";

// Registro rápido de cliente — o espelho do "Registro rápido" de Parceiros.
// Para quando só se tem o contato inicial de uma empresa com frota: nasce como
// lead (novo_lead), e o resto do cadastro a equipe completa depois. O primeiro
// contato (com a conversa exportada) entra pelo "Registrar Contato" do detalhe.

const empty = { company: "", contact: "", phone: "", region: "Grande São Paulo", fleetSize: "", notes: "" };

export default function QuickClient({ open, onClose, setClients, setTasks, userId }) {
  const [data, setData] = useState({ ...empty });
  const [errors, setErrors] = useState({});
  const set = (patch) => setData((p) => ({ ...p, ...patch }));
  const handleClose = () => { setData({ ...empty }); setErrors({}); onClose(); };

  const handleSubmit = () => {
    const err = {};
    if (!data.company.trim() && !data.phone.trim() && !data.contact.trim())
      err.company = "Informe ao menos o nome da empresa, contato ou telefone";
    setErrors(err);
    if (Object.keys(err).length) return;

    const today = getToday();
    const id = generateId();
    const c = {
      id, userId, stage: "novo_lead", starred: false,
      company: data.company.trim() || data.contact.trim() || data.phone.trim(),
      contact: data.contact.trim() || "", phone: data.phone.trim() || "",
      whatsapp: data.phone.trim() || "",
      region: data.region || "", fleetSize: data.fleetSize || "",
      notes: data.notes.trim() || "", source: "Registro rápido",
      systems: [], vehicleTypes: [], services: [], estimatedValue: 0,
      createdAt: today, lastContact: null, interactions: [],
      stageHistory: [{ from: null, to: "novo_lead", date: today, note: "Registro rápido de lead" }],
      nextAction: "Fazer primeiro contato", nextActionDate: today,
    };
    setClients((p) => [...p, c]);
    if (setTasks) setTasks((p) => [...p, {
      id: generateId(), title: `Fazer 1º contato — ${c.company}`, userId,
      type: "client", refId: id, dueDate: today, priority: "high", done: false,
      notes: "Registro rápido de cliente — fazer primeiro contato.",
    }]);
    handleClose();
  };

  return (
    <Modal open={open} onClose={handleClose} title="Registro rápido de cliente" w={500}>
      <div style={{ fontSize: 13, color: "#64748b", marginBottom: 14, lineHeight: 1.5 }}>
        Para quando você só tem o contato inicial de uma empresa com frota. Isso cria um <strong>lead</strong> — depois é só abrir o detalhe e <strong>Registrar Contato</strong> (anexando a conversa exportada) para começar o funil.
      </div>

      <Field label="Nome da empresa" required error={errors.company}>
        <input style={errors.company ? inputErrorStyle : inputStyle} value={data.company} onChange={(e) => set({ company: e.target.value })} placeholder="Ex: Transportadora Rápida Ltda" />
      </Field>

      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "0 12px" }}>
        <Field label="Nome do contato">
          <input style={inputStyle} value={data.contact} onChange={(e) => set({ contact: e.target.value })} placeholder="Quem atendeu" />
        </Field>
        <Field label="Telefone / WhatsApp">
          <input style={inputStyle} value={data.phone} onChange={(e) => set({ phone: maskPhone(e.target.value) })} placeholder="(00) 00000-0000" />
        </Field>
        <Field label="Região">
          <select style={selectStyle} value={data.region} onChange={(e) => set({ region: e.target.value })}>
            {REGIONS.map((r) => <option key={r} value={r}>{r}</option>)}
          </select>
        </Field>
        <Field label="Tamanho da frota">
          <select style={selectStyle} value={data.fleetSize} onChange={(e) => set({ fleetSize: e.target.value })}>
            <option value="">Selecione...</option>
            {FLEET_SIZES.map((f) => <option key={f.id} value={f.id}>{f.label}</option>)}
          </select>
        </Field>
      </div>

      <Field label="O que o cliente pediu / observação">
        <textarea style={{ ...inputStyle, minHeight: 70, resize: "vertical" }} value={data.notes} onChange={(e) => set({ notes: e.target.value })} placeholder="Descreva o pedido, o interesse, quem retornar contato, etc." />
      </Field>

      <div style={{ display: "flex", justifyContent: "flex-end", gap: 8, marginTop: 6 }}>
        <button onClick={handleClose} style={{ padding: "8px 16px", borderRadius: 6, border: "1px solid #e2e8f0", background: "#fff", color: "#64748b", fontSize: 13, fontWeight: 600, cursor: "pointer" }}>Cancelar</button>
        <button onClick={handleSubmit} style={{ padding: "8px 16px", borderRadius: 6, border: "none", background: "#0d9488", color: "#fff", fontSize: 13, fontWeight: 600, cursor: "pointer" }}>Salvar lead</button>
      </div>
    </Modal>
  );
}
